import css from './viewParameterSidePageContend.module.css'
import { IParameter } from '@/pages/Parameters/parameters.types'
import SeparateLine from '@/shared/Forms/SeparateLine'
import { format } from 'date-fns'
import confirmService from '@/services/ConfirmService/confirm.service'
import parametersApi from '@/pages/Parameters/parameters.api'
import parameterEvents from '@/pages/Parameters/events/parameter/parameter.events.ts'
import cn from './../../../../../utils/cn'
import ParameterUnitSpan from '../../ParameterUnitSpan'
import ParameterGroupBreadcrumbsPath from '../../ParameterGroupBreadcrumbsPath'
import ProtectedContent from '@/services/rights/ProtectedContent'
import FormEditButton from '@/shared/Buttons/FormEditButton'
import FormDeleteButton from '@/shared/Buttons/FormDeleteButton'

interface IProps {
  parameter: IParameter
  onEdit: () => void
  onClose: () => void
}

const ViewParameterSidePageContent = (props: IProps) => {
  const handleDelete = (parameterId: number) => {
    confirmService.requestConfirm({
      buttonType: 'primary',
      description: 'Вы действительно хотите удалить переменную?',
      onConfirm: () =>
        parametersApi.deleteParameter(parameterId).then((r) => {
          if (r.status === 'success') {
            parameterEvents.deleted(r.body.id)
          }
          props.onClose()
        }),
    })
  }

  return (
    <div className="flex-lines gap16" style={{ height: '100%' }}>
      <h4 className="text-heading-4" style={{ maxWidth: '90%' }}>
        {props.parameter.name}
      </h4>
      <SeparateLine />
      <div className={css.wrapperContent}>
        <div className="flex-lines gap16">
          <div className={css.sidePageGrid}>
            <ParameterField label="Дата создания" value={format(props.parameter.createdAt, 'dd.MM.yyyy, HH:mm:ss')} />
            <ParameterField label="Дата изменения" value={format(props.parameter.updatedAt, 'dd.MM.yyyy, HH:mm:ss')} />
          </div>
          <SeparateLine />
          <h5 className="text-heading-5">Параметры</h5>
          <div className={css.sidePageGrid}>
            <ParameterField label="ID" value={props.parameter.sourceId} />
            <ParameterField
              label="Расположение"
              value={<ParameterGroupBreadcrumbsPath groupId={props.parameter.groupId} isToggleButtonVisible />}
            />
            <ParameterField label="Тип данных" value={props.parameter.dataType} />
            <ParameterField label="Единица измерения" value={<ParameterUnitSpan unitId={props.parameter.unitId} />} />
            <ParameterField label="Комментарий" value={props.parameter.comment} />
          </div>
        </div>
      </div>

      <ProtectedContent requiredOneOf={['parameters:update', 'parameters:delete']}>
        <div className={css.actions}>
          <ProtectedContent requiredRight="parameters:update">
            <FormEditButton onClick={props.onEdit} />
          </ProtectedContent>
          <ProtectedContent requiredRight="parameters:delete">
            <FormDeleteButton onClick={() => handleDelete(props.parameter.id)} />
          </ProtectedContent>
        </div>
      </ProtectedContent>
    </div>
  )
}

const ParameterField = ({ label, value }: { label: string; value: string | React.ReactNode }) => (
  <>
    <div className={cn(css.label, 'text-nm', 'text-secondary')}>{label}:</div>
    <div className={cn(css.value, 'text-nm')}>{value || '-'}</div>
  </>
)

export default ViewParameterSidePageContent
